import { useCallback } from 'react';

import { REMOTE_FORM_STATE_KEY } from '@constants/apiConstants';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';

import { useSyncState } from './useSyncState';

const useSetRemoteFormState = <T extends object>(values: T) => {
  const [, setState] = useSyncState(REMOTE_FORM_STATE_KEY, values);
  const { isSyncedAppointment, hasControl } = useAppointmentContext();

  return useCallback(() => {
    if (!isSyncedAppointment || !hasControl) {
      return;
    }

    setState((prevState) => ({
      ...prevState,
      ...values,
    }));
  }, [setState, isSyncedAppointment, hasControl, values]);
};

export default useSetRemoteFormState;
